import { render, staticRenderFns } from "./ExportationFrameWalkingReathleticism.vue?vue&type=template&id=45bcfbce&scoped=true&"
import script from "./ExportationFrameWalkingReathleticism.vue?vue&type=script&lang=ts&"
export * from "./ExportationFrameWalkingReathleticism.vue?vue&type=script&lang=ts&"
import style0 from "./ExportationFrameWalkingReathleticism.vue?vue&type=style&index=0&id=45bcfbce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bcfbce",
  null
  
)

export default component.exports